import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { bottomNavigation, spaceBelowHeader } from '@ui/style/variables';
const useEventDetailsStyles = (tab = '') => {
    const { isMobileIpadNavigation } = useResponsive();
    const isTasksTab = tab === 'tasks';
    const isInvitationTab = tab === 'invitations';
    const isAttachmentTab = tab === 'attachments';
    const isReponsesTab = tab === 'responses';
    const headingHeight = 48;
    const spaceBelowHeading = 34;
    const pageEndPadding = 8;
    const extraPadding = isReponsesTab ? 80 : 90;
    const cardContainerHeight = `${142 + spaceBelowHeader + pageEndPadding}px`;
    const cardContainerHeightMobile = `${+bottomNavigation + extraPadding}px`;
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'hidden',
            height: '100%',
            px: isMobileIpadNavigation ? 0 : clamp.calculate(8, 32)
        },
        contentContainer: {
            // py: isTasksTab ? 0 : 2,
            // pt: isTasksTab && isMobileIpadNavigation ? 0 : isTasksTab ? 2 : undefined,
            pb: isAttachmentTab ? 0 : undefined,
            flexGrow: 1,
            // px: isMobileIpadNavigation && !isTasksTab ? 1 : undefined,
            overflowY: isReponsesTab ? 'hidden' : 'auto',
            // ...(isTasksTab || isInvitationTab
            //   ? { height: '100%' }
            //   : {
            //       maxHeight: isMobileIpadNavigation
            //         ? `calc(100dvh - ${cardContainerHeightMobile})`
            //         : `calc(100dvh - ${cardContainerHeight})`
            //     })
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            backgroundColor: (theme) => theme.palette.common.white,
            paddingBottom: (theme) => theme.spacing(1),
            paddingTop: (theme) => theme.spacing(2),
            // borderRadius: (theme) => theme.spacing(3),
            borderBottomLeftRadius: isTasksTab && isMobileIpadNavigation ? 0 : (theme) => theme.spacing(3),
            borderBottomRightRadius: isTasksTab && isMobileIpadNavigation ? 0 : (theme) => theme.spacing(3),
            px: clamp.calculate(16, 32),
            height: '100%'
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center'
        },
        mobileScreenAttachmentButton: {
            py: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        }
    };
};
export default useEventDetailsStyles;
